export default __webpack_public_path__ + "media/images/react_icons/trash_square_red-51e1ded498681b5553a81ffa433f5c76.svg";